/************************************************************************
Hawaiian Macadamia Nut Services
Alexander Self
6/19/17
All Actions for timesheet, auth interactions
************************************************************************/
import { browserHistory } from 'react-router';
import { AUTH_USER, UNAUTH_USER, AUTH_ERROR, ERROR, FETCH_TIMESHEET_DATA,
  ADD_EMPLOYEE_TO_TIMESHEET, REMOVE_EMPLOYEE_FROM_TIMESHEET, ADD_WORK_TO_TIMESHEET, EDIT_WORK_IN_TIMESHEET,
  REMOVE_WORK_FROM_TIMESHEET, ADD_EMPLOYEE_TO_GANG_TIMESHEET, REMOVE_EMPLOYEE_FROM_GANG_TIMESHEET,
  PREPARE_GANG_TIMESHEET, PREPARE_REG_TIMESHEET, SUBMIT_REG_TIMESHEET, SUBMIT_GANG_TIMESHEET,
  FETCH_TIMESHEETS, FETCH_MY_TIMESHEETS, FETCH_TIMESHEET_TO_EDIT, GET_TIMESHEET_DATES_TO_EDIT, REMOVE_WORK_FROM_EDIT_TIMESHEET,
  ADD_WORK_TO_EDIT_TIMESHEET, PREPARE_EDIT_TIMESHEET, SUBMIT_EDIT_TIMESHEET, FETCH_TIMESHEETS_TO_DELETE,
  DELETE_TIMESHEET, NULL, EMPLOYEE_AUTOCOMPLETE, DOWNLOAD_TIMESHEET, FETCH_PAY_PERIOD, FETCH_SUBACCOUNTS,
  FETCH_FIELDS_BY_LOC, SELECT_GANG_FOR_TIMESHEET, SELECT_GANG_FOR_GANG_TIMESHEET, FETCH_BLOCKS_BY_FIELD,
  FETCH_MY_EMPLOYEES_TIMESHEET, ADD_NEW_GANG_INFO_ROW, REMOVE_HARVEST_FROM_EDIT_TIMESHEET, ADD_HARVEST_TO_EDIT_TIMESHEET,
  FETCH_USER_PROFILE, FETCH_EMPLOYEE_TIMESHEETS, SELECT_COST_CENTER_BY_LOCATION, EDIT_WORK_RECORD, EDIT_WORK_IN_EDIT_TIMESHEET,
  EDIT_WORK_RECORD_EDIT_TS, ADD_WORK_TO_GANG_TIMESHEET, EDIT_WORK_IN_GANG_TIMESHEET, EDIT_GANG_WORK_RECORD, DELETE_WORK_IN_GANG_TIMESHEET,
  SELECT_HARVEST_TO_EDIT, EDIT_HARVEST, AUTOFILL_GANG_TIMESHEET
} from './types';
import { generateTSID, handleFormChecking, clearForm, fillEditForm, packageDashForm,
  generateGUID, fillIndividualWorkForm, fillEdit } from '../utils';
import { 
  ROOT_URL, 
  MAX_NON_REG_GRADE,
  DAYS_FOR_ADMINS 
} from '../constants';
import axios from 'axios';
import moment from 'moment';
const $ = window.$;
const Materialize = window.Materialize;
/*****************************************************
  Asynchronous Functions
*****************************************************/
/**
* signinUser(): Signs in a user
* @param {Object} email, password
* @returns {Object} JWT(Token)
* @called-in: ['/containers/auth/signin.js]
**/
export function signinUser({email, password}) {
  $('#preloader').css('display','block');
  return function(dispatch) {
    axios.post(`${ROOT_URL}/signin`, { email, password })
      .then((res) => {
        $('#preloader').css('display','none');
        // Save JSON Web Token to localStorage
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('email', email);
        // Authenticate user on redux front end
        dispatch(authUser(res.data.user));
        // Send user to protected component
        browserHistory.push('/dashboard');
      })
      .catch(() => {
        $('#preloader').css('display','none');
        dispatch(authError('Bad login Info'));
      });
  };
}
/**
* fetchPayPeriod(): Fetches the current pay period to limit date selections
* @returns {Object} current pay period dates; previous pay period dates(for last edits)
* @called-in: ['/containers/timesheet.js]
**/
export function fetchPayPeriod() {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchPayPeriod`, {
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => {
        let startDate = moment(res.data.payPeriod.startDate).format('YYYY-MM-DD');
        let endDate = moment(res.data.payPeriod.endDate).format('YYYY-MM-DD');
        let prevPPStartDate = moment(res.data.prevPP.startDate).format('YYYY-MM-DD');
        let prevPPEndDate = moment(res.data.prevPP.endDate).format('YYYY-MM-DD');
        dispatch({ type: FETCH_PAY_PERIOD, payload: { startDate, endDate }, prevPP: { startDate: prevPPStartDate, endDate: prevPPEndDate } });
      }).catch(err => dispatch(error(`There was an error fetching pay periods`)));
  }
}
/**
* fetchUserProfile(): Fetches the logged users profile
* @param {String} eid: employee id number
* @returns {Object} User profile
* @called-in: ['/containers/dashboard.js]
**/
export function fetchUserProfile(eid) {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchUserProfile`, {
      params: { eid },
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => {
        dispatch({ type: FETCH_USER_PROFILE, payload: res.data.profile });
      }).catch(err => dispatch(error(`There was an error fetching the users profile`)));
  }
}
/**
* fetchUser(): Fetches the logged user and runs a check on if they exist in the store
* @param {Object} store: redux store
* @returns {Object} User profile
* @called-in: ['index.js]
**/
export function fetchUser(store) {
  axios.get(`${ROOT_URL}/fetchUser`, {
    params: { token: localStorage.getItem('token') },
    headers: { authorization: localStorage.getItem('token') }
  }).then((res) => {
      store.dispatch(authUser(res.data.user));
      localStorage.setItem('token', res.data.token);
      browserHistory.push('/dashboard');
    }).catch((err) => store.dispatch(error(`There was an error fetching the user`)));
}
/**
* fetchEmployeesServer(): Fetches all employees, fields, costcenters, equipment
* @param {Object} user: Logged user
* @returns {Object} Active employees, fields, cost centers, equipment lists
* @called-in: ['/containers/timesheet.js','/containers/gang_builder.js']
**/
export function fetchTimesheetData(user) {
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchTimesheetData`, {
      params: { eid: user.eid },
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => {
        $('#preloader').css('display','none');
        dispatch({
          type: FETCH_TIMESHEET_DATA,
          payload: res.data,
          user
        });
      }).catch((err) => {
        $('#preloader').css('display','none');
        dispatch(error(`There was an error fetching employees`));
    });
  };
}
/**
* submitRegTimesheet(): Submits a regular timesheet for one or many employees
* @param {Array} employees: List of employees
* @param {Object} timesheet: All timesheet information to be applied to each employee
* @returns {Object} Employees, gangs who timesheet was submitted for
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_individual_modal.js']
**/
export function submitRegTimesheet(employees, timesheet, dates, user) {
  // Ensure user selects at least 1 employee
  if (employees.length === 0) return error('Please select one or more employees to submit a timesheet');
  if (timesheet.location === '') return error('Please select a location to submit a timesheet');
  if (timesheet.secondaryTS.workPerformed.length === 0) return error('Please add a work record before submitting a timesheet');
  if (handleFormChecking(timesheet, error) === 1) return { type: NULL };
  let regHours = timesheet.secondaryTS.workPerformed.filter((w) => w.subAccount !== '' && (w.subAccount.split('-')[2] !== '111' && w.subAccount.split('-')[2] !== '129' && w.subAccount.split('-')[2] !== '150'))
                                                    .reduce((acc, { hours }) => { return acc + parseFloat(hours); }, 0);
  if (regHours > 8) return error('Work is over 8 hours. Please add the correct overtime or doubletime subaccount to one or more records.');
  // Ensure supervisors cannot submit timesheets with temp. grades that do not exist
  // Added 10.25.21
  for (let e of employees) {
    let { positionType, firstName, lastName } = e
    for (let w of timesheet.secondaryTS.workPerformed) {
      if (w.tempGrade) {
        if (!positionType.match(/Regular/) && Number(w.tempGrade) > MAX_NON_REG_GRADE) {
          return error(`${firstName} ${lastName}, ${positionType} requires temporary grade <= ${MAX_NON_REG_GRADE}.`)
        }
      }
    }
  }

  document.getElementById('reg-ts-btn').disabled = true;
  $('#preloader').css('display','block');
  // If a user is a supervisor, 10am of new pay period is cutoff for editing
  let lastDay = moment().format('YYYY-MM-DD');
  let { prevPPStartDate, prevPPEndDate, payPeriodStartDate } = dates;

  if (lastDay === moment(payPeriodStartDate).format('YYYY-MM-DD') && moment().hour() >= 10 && user.level < 4) {
    for (var m = moment(prevPPStartDate); m.isBefore(moment(prevPPEndDate).add(1, 'days')); m.add(1, 'days')) {
      if (m.format('YYYY-MM-DD') === moment(timesheet.date).format('YYYY-MM-DD')) {
        $('#preloader').css('display','none');
        document.getElementById('reg-ts-btn').disabled = false;
        return error('Cannot submit timesheets for a previous pay period past 10am');
      }
    }
  }
  return (dispatch) => {
    axios.post(`${ROOT_URL}/submitRegTimesheet`, { employees, timesheet },
      { headers: { authorization: localStorage.getItem('token') } }
    )
      .then((res) => {
        $('#preloader').css('display','none');
        document.getElementById('reg-ts-btn').disabled = false;
        // If timesheet exists for one or more individuals
        if (res.data.exists) return error(res.data.msg);
        clearForm('basic-ts-form');
        Materialize.toast(res.data.msg, 4000, 'rounded green');
        dispatch({type: SUBMIT_REG_TIMESHEET, payload: res.data.employees, gangs: res.data.gangs});
      }).catch((err) => {
        $('#preloader').css('display','none');
        dispatch(error(`There was an error submitting a timesheet`));
      });
  };
}
/**
* submitGangTimesheet(): Submits a gang timesheet(hand harvest) for one or many employees
* @param {Object} timesheet: All employees and timesheet information
* @returns {Object} Employees, gangs: Timesheets that were just submitted
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_gang_modal.js']
**/
export function submitGangTimesheet(timesheet, dates, user) {
  if (timesheet.emps.length === 0) return error('Please select one or more employees to submit a timesheet');
  if (timesheet.location === '') return error('Please select a location to submit a timesheet');
  if (timesheet.date === '') return error('Please select a date to submit a timesheet');
  if (timesheet.round === '' || Number(timesheet.round) < 1) return error('Please enter a round to submit a timesheet');
  document.getElementById('gang-ts-btn').disabled = true;

  $('#preloader').css('display','block');

  // If a user is a supervisor, 10am of new pay period is cutoff for editing
  let lastDay = moment().format('YYYY-MM-DD');
  let { prevPPStartDate, prevPPEndDate, payPeriodStartDate } = dates;

  if (lastDay === moment(payPeriodStartDate).format('YYYY-MM-DD') && moment().hour() >= 10 && user.level < 4) {
    for (var m = moment(prevPPStartDate); m.isBefore(moment(prevPPEndDate).add(1, 'days')); m.add(1, 'days')) {
      if (m.format('YYYY-MM-DD') === moment(timesheet.date).format('YYYY-MM-DD')) {
        $('#preloader').css('display','none');
        document.getElementById('reg-ts-btn').disabled = false;
        return error('Cannot submit timesheets for a previous pay period past 10am');
      }
    }
  }
  return (dispatch) => {
    axios.post(`${ROOT_URL}/submitGangTimesheet`, { timesheet }, {
      headers: { authorization: localStorage.getItem('token') }
    })
      .then((res) => {
        $('#preloader').css('display','none');
        document.getElementById('gang-ts-btn').disabled = false;
        if (res.data.exists) return error(res.data.msg);
        clearForm('gang-ts-form');
        Materialize.toast(res.data.msg, 4000, 'rounded green');
        dispatch({type: SUBMIT_GANG_TIMESHEET, payload: res.data.employees, gangs: res.data.gangs});
      }).catch((err) => {
        $('#preloader').css('display','none');
        dispatch(error(`There was an error submitting a gang timesheet`));
      });
  }
}
/**
* fetchTimesheets(): Fetches all timesheets by date
* @param {Object} date: Date string
* @returns {Array} Timesheets: all timesheets for a selected date
* @called-in: ['/components/timesheets/view/timesheet_view.js']
**/
export function fetchTimesheets(date) {
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchTimesheets`, {
      params: { date },
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => {
        $('#preloader').css('display','none');
        $('#timesheet-view').fadeIn({ duration: 300 });
        //console.log(res.data.timesheets)
        dispatch({ type: FETCH_TIMESHEETS, payload: res.data.timesheets });
    }).catch((err) => {
      $('#preloader').css('display','none');
      dispatch(error(`There was an error fetching timesheets`));
    });
  }
}
/**
* fetchEmployeeTimesheets(): Fetches all timesheets by employee
* @param {Object} employee: employee object
* @returns {Array} Timesheets: All timesheets for a selected employee
* @called-in: ['/components/timesheets/view/timesheet_view.js']
**/
export function fetchEmployeeTimesheets(employee) {
  let eid = employee.eid;
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchEmployeeTimesheets`, {
      params: { eid },
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => {
        document.getElementById('employee-search-ts').value = '';
        $('#preloader').css('display','none');
        $('#timesheet-view').fadeIn({ duration: 300 });
        dispatch({ type: FETCH_EMPLOYEE_TIMESHEETS, payload: res.data });
    }).catch((err) => {
      $('#preloader').css('display','none');
      dispatch(error(`There was an error fetching timesheets`));
    });
  }
}
/**
* fetchMyTimesheets(): Fetches all timesheets submitted by a user
* @param {String} eid: Employee ID of the user
* @returns {Array} Timesheets: All timesheets for a given user on a present date
* @called-in: ['/components/timesheets/view/timesheet_view.js']
**/
export function fetchMyTimesheets(eid, date) {
  if (!date) date = moment().format('YYYY-MM-DD');
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchMyTimesheets`, {
      params: { eid, date },
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => {
        $('#preloader').css('display','none');
        $('#timesheet-view').fadeIn({ duration: 300 });
        dispatch({ type: FETCH_MY_TIMESHEETS, payload: res.data.timesheets, date });
    }).catch((err) => {
      $('#preloader').css('display','none');
      dispatch(error(`There was an error fetching timesheets`));
    });
  }
}
/**
* fetchTimesheetDatesToEdit(): Fetches all timesheet dates available for editing
* @param {Object} employee: employee object
* @param {Object} dates: pay period dates
* @param {Object} user: logged in user object
* @returns {Array} Timesheet dates: All timesheets for the current pay period
* @called-in: ['/components/timesheets/edit/timesheet_edit.js']
**/
export function fetchTimesheetDatesToEdit(employee, dates, user) {
  if (!employee) return error('Please select an employee');
  $('#preloader').css('display','block');
  clearForm("edit-ts-form");
  clearForm("edit-second-ts-form");
  // If a user is a supervisor, 10am of new pay period is cutoff for editing
  let lastDay = moment().format('YYYY-MM-DD');
  // See constants.js to update DAYS_FOR_ADMINS
  let lastDayForAdmins = moment(dates.prevPPEndDate).add(DAYS_FOR_ADMINS, 'days').format('YYYY-MM-DD');

  if (lastDay === moment(dates.payPeriodStartDate).format('YYYY-MM-DD') && moment().hour() < 10) {
    dates.payPeriodStartDate = dates.prevPPStartDate;
  }
  // If a user is an admin, the first Friday of new pay period is cutoff for editing the previous pay periods timesheets
  // This is access is available for the accounting team to resolve lingering cost center, sub account issues with TM and GP
  if (lastDayForAdmins >= lastDay && user.level === 4) {
    dates.payPeriodStartDate = dates.prevPPStartDate//moment(dates.prevPPStartDate).subtract(DAYS_FOR_ADMINS, 'days').format('YYYY-MM-DD') //dates.prevPPStartDate; // moment(dates.prevPPStartDate).subtract(DAYS_FOR_ADMINS, 'days').format('YYYY-MM-DD')
  }

  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchTimesheetDatesToEdit`, {
      params: { eid: employee.eid, dates },
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => {
        $('#preloader').css('display','none');
        dispatch({
          type: GET_TIMESHEET_DATES_TO_EDIT,
          payload: res.data.timesheetDates,
          employee
        });
      }).catch((err) => {
        $('#preloader').css('display','none');
        dispatch(error(`There was an error fetching timesheets dates to edit`));
      });
  }
}
/**
* fetchTimesheetToEdit(): Fetches timesheet information of a particular date for editing
* @param {String} tsID: Timesheet id
* @param {String} eid: Employee id
* @returns {Object} Timesheet: All timesheet information; fields, subaccounts
* @called-in: ['/components/timesheets/edit/timesheet_edit.js->timesheet_edit_list.js']
**/
export function fetchTimesheetToEdit(tsID, eid) {
  $('#preloader').css('display','block');
  clearForm("edit-ts-form");
  clearForm("edit-second-ts-form");
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchTimesheetToEdit`, {
        params: { tsID, eid },
        headers: { authorization: localStorage.getItem('token') }
      }).then((res) => {
          let tsObj = {
            timesheet: res.data.timesheet[0],
            subTimesheets: res.data.subTimesheet,
            harvestTimesheet: res.data.harvestTimesheet,
            subAccounts: res.data.subAccounts,
            fields: res.data.fields
          };

          $('#preloader').css('display','none');
          dispatch(getTimesheetToEdit(tsObj));
        }).catch((err) => {
          $('#preloader').css('display','none');
          dispatch(error(`There was an error fetching timesheets to edit`));
        });
  }
}
/**
* submitEditTimesheet(): Submits an editing timesheet
* @param {String} ts: timesheet object
* @returns {Object} Redux dispatch
* @called-in: ['/components/timesheets/edit/timesheet_edit.js->timesheet_edit_modal.js']
**/
export function submitEditTimesheet(ts) {
  console.log(ts)
  if (Object.keys(ts.employee).length === 0) {
    return error('Please select an employee to edit a timesheet');
  }
  if (ts.timesheet.reasonForEdit === '') {
    return error('Please enter a reason for editing the timesheet');
  }
  if (ts.harvestTimesheet.length > 0 && (Number(ts.timesheet.round) < 1 || ts.timesheet.round === '')) {
    return error('Please enter a round for hand harvest timesheets');
  }

  let regHours = ts.subTimesheets.filter((w) => w.subAccount !== '' && (w.subAccount.split('-')[2] !== '111' && w.subAccount.split('-')[2] !== '129' && w.subAccount.split('-')[2] !== '150'))
                                                    .reduce((acc, { hours }) => { return acc + parseFloat(hours); }, 0);
  let harvestHours = ts.harvestTimesheet.reduce((acc, { hours }) => { return acc + parseFloat(hours); }, 0);
  if ((regHours + harvestHours) > 8) return error('Work is over 8 hours. Please add the correct overtime or doubletime subaccount to one or more records.');

  let dateTimeEdited = moment().format('YYYY-MM-DD hh:mm:ss');
  ts.timesheet.dateTimeEdited = dateTimeEdited;
  $('#preloader').css('display','block');

  return (dispatch) => {
    axios.post(`${ROOT_URL}/submitEditTimesheet`, { ts }, {
      headers: { authorization: localStorage.getItem('token') }
    })
      .then((res) => {
        $('#preloader').css('display','none');
        Materialize.toast(res.data.msg, 4000, 'rounded green');
        clearForm("edit-ts-form");
        clearForm("edit-second-ts-form");
        return dispatch({type: SUBMIT_EDIT_TIMESHEET});
      }).catch((err) => {
        $('#preloader').css('display','none');
        dispatch(error(`There was an error submitting a timesheet to edit`));
      });
  };
}
/**
* fetchTimesheetsToDelete(): Fetches timesheet information of a particular date for deleting
* @param {Object} employee: employee object
* @param {Object} dates: dates object
* @returns {Array} Timesheets to delete
* @called-in: ['/components/timesheets/delete/timesheet_delete.js']
**/
export function fetchTimesheetsToDelete(employee, dates) {
  if (!employee) return error('Please select an employee');
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchTimesheetsToDelete`, {
        params: { employee, dates },
        headers: { authorization: localStorage.getItem('token') }
      }).then((res) => {
          $('#preloader').css('display','none');
          dispatch({
            type: FETCH_TIMESHEETS_TO_DELETE,
            payload: res.data.timesheets,
            employee
          });
        }).catch((err) => dispatch(error(`There was an error fetching timesheets to delete.`)));
  }
}
/**
* deleteTimesheet(): Deletes a selected timesheet
* @param {Object} ts: Timesheet object
* @param {Object} employee: Employee object
* @returns {Object} Redux dispatch
* @called-in: ['/components/timesheets/delete/timesheet_delete.js->timesheet_delete_modal.js']
**/
export function deleteTimesheet(ts, employee) {
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.post(`${ROOT_URL}/deleteTimesheet`, { ts, employee }, {
      headers: { authorization: localStorage.getItem('token') }
    })
      .then((res) => {
        $('#preloader').css('display','none');
        Materialize.toast(res.data.msg, 4000, 'rounded green');
        dispatch({ type: DELETE_TIMESHEET });
      }).catch((err) => dispatch(error(`There was an error deleting a timesheet`)));
  }
}
/**
* downloadTimesheets(): Downloads timesheets for a particular date or range of dates
* @param {Object} dates: Dates object
* @param {String} email: Employee email(where downloaded timesheets will be sent to)
* @returns {String} Download message
* @called-in: ['/components/timesheets/view/timesheet_view.js->timesheet_download.js']
**/
export function downloadTimesheets(dates, email) {
  if (dates.dateFrom === '' || dates.dateTo === '') {
    return error('Please select a date range');
  }
  $('#preloader').css('display','block');
  clearForm('ts-download-form');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/downloadTimesheets`, {
      params: { dateFrom: dates.dateFrom, dateTo: dates.dateTo, email },
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => {
        $('#preloader').css('display','none');
        Materialize.toast(res.data.msg, 4000, 'rounded green');
        dispatch({ type: DOWNLOAD_TIMESHEET, payload: res.data });
      }).catch((err) => {
        $('#preloader').css('display','none');
        dispatch(error(`There was an error emailing the timesheets`))
      });
  }
}
/**
* downloadIndividualTimesheets(): Downloads timesheets for a date or range of dates of an individual employee
* @param {Object} dates: Dates object
* @param {String} email: Employee email(where downloaded timesheets will be sent to)
* @param {Object} emp: Employee object
* @returns {String} Download message
* @called-in: ['/components/timesheets/view/timesheet_view.js->timesheet_download.js']
**/
export function downloadIndividualTimesheets(dates, email, emp) {
  if (dates.dateFrom === '' || dates.dateTo === '') {
    return error('Please select a date range');
  }
  if (!emp) return error('Please select an employee');
  $('#preloader').css('display','block');
  clearForm('ts-download-form');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/downloadIndividualTimesheets`, {
      params: { dateFrom: dates.dateFrom, dateTo: dates.dateTo, email, emp },
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => {
        document.getElementById('employee-search-ts-download').value = '';
        document.getElementById('ts-download-3').value = '';
        document.getElementById('ts-download-4').value = '';
        $('#preloader').css('display','none');
        Materialize.toast(res.data.msg, 4000, 'rounded green');
        dispatch({ type: DOWNLOAD_TIMESHEET, payload: res.data });
      }).catch((err) => {
        $('#preloader').css('display','none');
        dispatch(error(`There was an error emailing the timesheets`))
      });
  }
}
/**
* fetchSubAccounts(): Fetches subaccounts based on a selected cost center
* @param {String} costCenter: Cost center selected
* @returns {Array} All subaccounts listed under a cost center
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_form.js',
               '/components/timesheets/create/timesheet_create.js->timesheet_gang_form.js',
               '/components/timesheets/edit/timesheet_edit.js->timesheet_edit_form.js']
**/
export function fetchSubAccounts(costCenter) {
  const arr = costCenter.split('-');
  let cc = arr[0];
  let loc = arr[arr.length - 1];
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchSubAccounts`, {
      params: { cc, loc },
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => {
        $('#preloader').css('display','none'); dispatch({ type: FETCH_SUBACCOUNTS, payload: res.data });
      }).catch((err) => dispatch(error(`There was an error fetching subAccounts`)));
  }
}
/**
* fetchFieldsByLoc(): Fetches fields based on selected location
* @param {String} loc: Location(71,72)
* @returns {Array} All fields based on location
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_form.js',
               '/components/timesheets/create/timesheet_create.js->timesheet_gang_form.js',
               '/components/timesheets/edit/timesheet_edit.js->timesheet_edit_form.js']
**/
export function fetchFieldsByLoc(loc) {
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchFieldsByLoc`, {
      params: { loc },
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => {
        $('#preloader').css('display','none');
        dispatch({ type: FETCH_FIELDS_BY_LOC, payload: res.data.fields });
      }).catch((err) => dispatch(error(`There was an error fetching fields by location`)));
  }
}
/**
* fetchBlocksByField(): Fetches blocks based on selected field
* @param {String} field: Field number
* @returns {Array} All blocks based on field
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_form.js',
               '/components/timesheets/create/timesheet_create.js->timesheet_gang_form.js',
               '/components/timesheets/create/timesheet_create.js->gang_autofill_form.js',
               '/components/timesheets/edit/timesheet_edit.js->timesheet_edit_form.js']
**/
export function fetchBlocksByField(field) {
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchBlocksByField`, {
      params: { field },
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => {
        $('#preloader').css('display','none');
        dispatch({ type: FETCH_BLOCKS_BY_FIELD, payload: res.data.blocks });
      }).catch((err) => dispatch(error(`There was an error fetching blocks by field`)));
  }
}
/*****************************************************
  Synchronous Functions
*****************************************************/
/**
* signoutUser(): Signs a user out of the applciation
* @returns {Object} Unauthorize user
* @notes Make sure to remove token for JWT signout
* @called-in: ['/containers/auth/signout.js']
**/
export function signoutUser() {
  // Destroy JWT token
  localStorage.removeItem('token');
  localStorage.removeItem('email');
  return {
    type: UNAUTH_USER
  };
}
/**
* authUser(): Authenticates a user
* @returns {Object} Authorized user
* @notes
* @called-in: ['/actions/index.js->signinUser(),fetchUser()']
**/
export function authUser(user) {
  return {
    type: AUTH_USER,
    payload: user
  };
}
/****************************** CREATE & VIEW **********************************/
/**
* addEmployeeToTimesheet(): Adds an employee for timesheet submission
* @param {Object} emp: Employee for timesheet submission
* @returns {Object} Employee
* @called-in: ['/components/timesheets/create/timesheet_create.js->employee_list.js']
**/
export function addEmployeeToTimesheet(emp) {
  return {
    type: ADD_EMPLOYEE_TO_TIMESHEET,
    payload: emp
  };
}
/**
* addWorkToTimesheet(): Adds specific work for employees for timesheet submission
* @param {Object} work: Work record for timesheet submission
* @returns {Object} work
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_form.js']
**/
export function addWorkToTimesheet(work) {
  return {
    type: ADD_WORK_TO_TIMESHEET,
    payload: work
  };
}
/**
* addWorkToTimesheet(): Adds specific work for employees for gang timesheet submission
* @param {Object} work: Work record in timesheet
* @returns {Object} work
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_gang_form.js']
**/
export function addWorkToGangTimesheet(work) {
  return {
    type: ADD_WORK_TO_GANG_TIMESHEET,
    payload: work
  };
}
/**
* editWorkInTimesheet(): Sets a specific work record and prefills the form to edit in a timesheet
* @param {Object} work: Work record in timesheet
* @returns {Object} work
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_form.js']
**/
export function editWorkInTimesheet(work) {
  $('#ind-work-edit-btn').css('display','block');
  fillIndividualWorkForm(work, 'second-ts-form');
  return {
    type: EDIT_WORK_IN_TIMESHEET,
    payload: work
  };
}
/**
* editWorkRecord(): Edits a specific work record on a timesheet
* @param {Object} work: Work record in timesheet
* @returns {Object} work
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_form.js']
**/
export function editWorkRecord(work) {
  $('#ind-work-edit-btn').css('display','none');
  return {
    type: EDIT_WORK_RECORD,
    payload: work
  };
}
/**
* editGangWorkRecord(): Edits a work record in a gang timesheet
* @param {Object} work: Work record in timesheet
* @returns {Object} work
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_form.js']
**/
export function editGangWorkRecord(work) {
  $('#gang-work-edit-btn').css('display','none');
  return {
    type: EDIT_GANG_WORK_RECORD,
    payload: work
  };
}
/**
* editGangWorkInTimesheet(): Sets a specific work record and prefills the gang form to edit in a timesheet
* @param {Object} work: Work record in timesheet
* @returns {Object} work
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_gang_form.js']
**/
export function editGangWorkInTimesheet(work) {
  $('#gang-work-edit-btn').css('display','block');
  fillIndividualWorkForm(work, 'gang-work-form');
  return {
    type: EDIT_WORK_IN_GANG_TIMESHEET,
    payload: work
  };
}
/**
* editWorkInEditTimesheet(): Sets a specific work record and prefills the edit form to edit in a timesheet
* @param {Object} work: Work record in timesheet
* @returns {Object} work
* @called-in: ['/components/timesheets/edit/timesheet_edit.js->timesheet_edit_form.js']
**/
export function editWorkInEditTimesheet(work) {
  $('#ind-work-edit-ts-btn').css('display','block');
  fillIndividualWorkForm(work, 'edit-second-ts-form');
  return {
    type: EDIT_WORK_IN_EDIT_TIMESHEET,
    payload: work
  };
}
/**
* editWorkInEditTimesheet(): Edits a work record in a edit timesheet
* @param {Object} work: Work record in timesheet
* @returns {Object} work
* @called-in: ['/components/timesheets/edit/timesheet_edit.js->timesheet_edit_form.js']
**/
export function editWorkRecordInEditTimesheet(work) {
  $('#ind-work-edit-ts-btn').css('display','none');
  return {
    type: EDIT_WORK_RECORD_EDIT_TS,
    payload: work
  };
}
/**
* deleteWorkInGangTimesheet(): Deletes a work record in a gang timesheet
* @param {String} workId: Work id record in timesheet
* @returns {Object} workId
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_gang_form.js->gang_work_table.js']
**/
export function deleteWorkInGangTimesheet(workId) {
  return {
    type: DELETE_WORK_IN_GANG_TIMESHEET,
    payload: workId
  };
}
/**
* removeEmployeeFromTimesheet(): Removes an employee from timesheet submission list
* @param {Object} emp: employee object
* @returns {Object} emp
* @called-in: ['/components/timesheets/create/timesheet_create.js->employee_list.js']
**/
export function removeEmployeeFromTimesheet(emp) {
  return {
    type: REMOVE_EMPLOYEE_FROM_TIMESHEET,
    payload: emp
  };
}
/**
* removeWorkFromTimesheet(): Removes specific work from a timesheet
* @param {String} workId: Work id record in timesheet
* @returns {Object} workId
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_form.js->add_work_table.js']
**/
export function removeWorkFromTimesheet(workId) {
  return {
    type: REMOVE_WORK_FROM_TIMESHEET,
    payload: workId
  };
}
/**
* addEmployeeToGangTS(): Adds employees to gang timesheets
* @param {String} emp: employee object
* @returns {Object} emp
* @called-in: ['/components/timesheets/create/timesheet_create.js->employee_list.js']
**/
export function addEmployeeToGangTS(emp) {
  return {
    type: ADD_EMPLOYEE_TO_GANG_TIMESHEET,
    payload: emp
  };
}
/**
* removeEmployeeFromGangTS(): Removes employees from gang timesheets
* @param {String} eid: employee id
* @returns {Object} eid
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_gang_form.js']
**/
export function removeEmployeeFromGangTS(eid) {
  return {
    type: REMOVE_EMPLOYEE_FROM_GANG_TIMESHEET,
    payload: eid
  };
}
/**
* prepareGangTS(): Prepares the gang timesheet that is to be submitted for review
* @param {Array} gangTS: array of employee timesheet objects
* @param {String} submitter: employee id of supervisor
* @param {String} location: location of work
* @param {String} date: date string
* @returns {Object} payload: prepared timesheet
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_gang_form.js']
**/
export function prepareGangTS(gangTS, submitter, location, date, round) {
  return {
    type: PREPARE_GANG_TIMESHEET,
    payload: {
      timesheetID: generateTSID(),
      submitter,
      location,
      date,
      round,
      ...gangTS
    }
  };
}
/**
* prepareRegTS(): Prepares the individual timesheet that is to be submitted for review
* @param {Object} formObj: Timesheet form object
* @param {Array} addedWork: array of work records
* @param {String} submitter: employee id of supervisor
* @returns {Object} payload: prepared timesheet
* @called-in: ['/components/timesheets/create/timesheet_create.js']
**/
export function prepareRegTS(formObj, addedWork, submitter) {
  let regHours = 8;
  let dustPay;
  let totalHours = addedWork.reduce((acc, { hours }) => { return acc + parseFloat(hours); }, 0);
  let overTime = addedWork.filter((w) => w.subAccount !== '' && (w.subAccount.split('-')[2] === '111' || w.subAccount.split('-')[2] === '150'))
                          .reduce((acc, { hours }) => { return acc + parseFloat(hours); }, 0);
  let doubleTime = addedWork.filter((w) => w.subAccount !== '' && w.subAccount.split('-')[2] === '129')
                            .reduce((acc, { hours }) => { return acc + parseFloat(hours); }, 0);

  if (totalHours <= 8) regHours = totalHours;
  // Handle dust pay: Added 1/18/18
  if (document.getElementById('dustPay').checked) dustPay = 1;
  else dustPay = 0;
  formObj.dustPay = dustPay;
  return {
    type: PREPARE_REG_TIMESHEET,
    payload: {
      timesheetID: generateTSID(),
      submitter: submitter,
      regHours: regHours.toFixed(2),
      otHours: overTime.toFixed(2),
      doubleTime: doubleTime.toFixed(2),
      summaryOfHours: totalHours.toFixed(2),
      gang: formObj.regGangNo, // No gang form input for individual timesheets
      ...formObj,
      secondaryTS: {
        workPerformed: addedWork
      }
    }
  };
}
/************************************ EDIT *************************************/
/**
* getTimesheetToEdit(): Prefill edit form and pull employees timesheet
* @param {Object} tsObj: Timesheet form object
* @returns {Object} payload: prepared timesheet
* @called-in: ['/actions/index.js']
**/
function getTimesheetToEdit(tsObj) {
  let round = 1;
  if (tsObj.harvestTimesheet.length > 0) round = tsObj.harvestTimesheet[0].round;
  setTimeout(() => {
    fillEditForm({ ...tsObj, round });
    document.getElementById('edit-ts-date').disabled = true;
  }, 100);
  return {
    type: FETCH_TIMESHEET_TO_EDIT,
    payload: {
      timesheet: tsObj.timesheet,
      subTimesheets: tsObj.subTimesheets,
      removedWork: [],
      subAccounts: tsObj.subAccounts,
      harvestTimesheet: tsObj.harvestTimesheet,
      removedHarvest: [],
      block: tsObj.timesheet.block // Pass in block and concat to state; helps with prefilling timesheet for edit
    },
    fields: tsObj.fields
  };
}
/**
* addWorkToEditTimesheet(): Add work to a timesheet being edited
* @param {Object} work: work object
* @returns {Object} payload: prepared timesheet
* @called-in: ['/components/timesheets/edit/timesheet_edit.js->timesheet_edit_form.js']
**/
export function addWorkToEditTimesheet(work) {
  return {
    type: ADD_WORK_TO_EDIT_TIMESHEET,
    payload: work
  };
}
/**
* removeWorkFromEditTimesheet(): Remove work from a timesheet being edited
* @param {Number} id: id of work object
* @returns {Object} payload: prepared timesheet
* @called-in: ['/components/timesheets/edit/timesheet_edit.js->timesheet_edit_form.js']
**/
export function removeWorkFromEditTimesheet(id) {
  return {
    type: REMOVE_WORK_FROM_EDIT_TIMESHEET,
    payload: id
  };
}
/**
* prepareEditTS(): Prepares a timesheet for submission. Any calculations, groupings, etc
* @param {Object} timesheet: timesheet object
* @param {Array} addedWork: array of work objects
* @param {String} submitter: employee id of submitter
* @param {Array} removedWork: array of work objects
* @param {Array} harvestTimesheet: array of harvest objects
* @param {Array} removedHarvest: array of harvest objects to delete
* @returns {Object} payload: prepared timesheet
* @called-in: ['/components/timesheets/edit/timesheet_edit.js->timesheet_edit_form.js']
**/
export function prepareEditTS(timesheet, addedWork, submitter, removedWork, harvestTimesheet, removedHarvest) {
  let ts = packageDashForm('edit-ts-form');
  let regHours = 0, totalRegWorkHours = 0, totalHarvestHours = 0, overTime = 0, doubleTime = 0, workHours = 0, harvestHours = 0, totalHours = 0;
  let dustPay;

  /* Account for subtimesheets */
  if (addedWork.length > 0) {
    workHours = addedWork.filter((w) => w.subAccount !== '' && w.subAccount.split('-')[2] !== '111' && w.subAccount.split('-')[2] !== '150' && w.subAccount.split('-')[2] !== '129')
                         .reduce((acc, { hours }) => { return acc + parseFloat(hours); }, 0);
    overTime = addedWork.filter((w) => w.subAccount !== '' && (w.subAccount.split('-')[2] === '111' || w.subAccount.split('-')[2] === '150'))
                        .reduce((acc, { hours }) => { return acc + parseFloat(hours); }, 0);
    doubleTime = addedWork.filter((w) => w.subAccount !== '' && w.subAccount.split('-')[2] === '129')
                          .reduce((acc, { hours }) => { return acc + parseFloat(hours); }, 0);
    totalRegWorkHours += workHours;
  }
  /* Account for harvest */
  if (harvestTimesheet.length > 0) {
    harvestHours = harvestTimesheet.reduce((acc, { hours }) => { return acc + parseFloat(hours); }, 0);
    totalHarvestHours += harvestHours;
    // Catch hours > 8
    if (harvestHours > 8) overTime += (harvestHours - 8);
    if (Number(ts.round) > 0) {
      harvestTimesheet = harvestTimesheet.map((h) => {
        return { ...h,
          round: Number(ts.round)
        }
      })
    }
  }
  // Total Work hours calculated
  totalHours += totalRegWorkHours;
  // Total Harvest hours calculated
  totalHours += totalHarvestHours;

  // If total hours is less than 8 hours, reg hours is totalHours
  if (totalHours > 8) {
    regHours = 8;
    //if (!(doubleTime > 0)) overTime = (totalHours - 8).toFixed(2);
  } else {
    regHours = totalHours;
  }
  if (isNaN(regHours)) {
    regHours = 0.00;
    totalHours = 0.00;
  }

  let paycodeHours = addedWork.filter((w) => w.paycode !== '')
                              .reduce((acc, cur) => { return acc + Number(cur.hours) },0)
  regHours += paycodeHours
  if (document.getElementById('edit-ts-dustPay').checked) dustPay = 1;
  else dustPay = 0;
  ts.dustPay = dustPay;

  return {
    type: PREPARE_EDIT_TIMESHEET,
    payload: {
      timesheet: {
        ...ts,
        date: ts.date,
        timesheetID: timesheet.timesheetID,
        submitter,
        eid: timesheet.eid,
        regHours: regHours.toFixed(2),
        otHours: parseFloat(overTime).toFixed(2),
        doubleTime: parseFloat(doubleTime).toFixed(2),
        summaryOfHours: (Number(workHours) + Number(harvestHours) + Number(overTime) + Number(doubleTime) + Number(paycodeHours))//.toFixed(2)
      },
      subTimesheets: addedWork,
      removedWork: removedWork,
      harvestTimesheet,
      removedHarvest
    }
  };
}
/**
* employeeAutocomplete(): Selects an employee based on autocomplete input
* @param {Object} val: employee object
* @param {Object} id: input id-> document.getElementById(id)
* @returns {Object} payload: employee name
* @called-in: ['/components/timesheets/create/timesheet_create.js']
**/
export function employeeAutocomplete(val, id) {
  document.getElementById(id).value = '';

  return {
    type: EMPLOYEE_AUTOCOMPLETE,
    payload: val,
    id
  };
}

/* Selects a gang and populates the employee timesheet list */
export function selectGangForTimesheet(gang) {
  document.getElementById('regGangNo').value = gang.gangId;

  return {
    type: SELECT_GANG_FOR_TIMESHEET,
    payload: gang
  };
}

/* Selects a gang and populates the gang timesheet list */
export function selectGangForGangTimesheet(gang) {
  document.getElementById('gangNo').value = gang.gangId;
  document.getElementById('gangShift').value = 1;

  return {
    type: SELECT_GANG_FOR_GANG_TIMESHEET,
    payload: gang
  };
}

/*****************************************************
  Error Functions
*****************************************************/
export function authError(err) {
  Materialize.toast(err, 4000, 'rounded red');
  return {
    type: AUTH_ERROR,
    payload: err
  };
}

export function error(err) {
  Materialize.toast(err, 4000, 'rounded red');
  return {
    type: ERROR,
    err
  };
}
export function formError(err) {
  return {
    type: ERROR,
    err
  };
}
/* Fetches the users employees if they have any */
export function fetchMyEmployees(eid) {
  return {
    type: FETCH_MY_EMPLOYEES_TIMESHEET,
    payload: eid
  };
}
/* Adds a new row for employees to add different hours, trees, bags, per field */
export function addNewGangInfoRow(eid) {
  return {
    type: ADD_NEW_GANG_INFO_ROW,
    payload: eid
  };
}

/* Removes a harvest record from timesheet */
export function removeHarvest(id) {
  return {
    type: REMOVE_HARVEST_FROM_EDIT_TIMESHEET,
    payload: id
  };
}
/* Adds a harvest record to timesheet */
export function addHarvest(harvest) {
  if (harvest.hours === '' || harvest.bags === '' || harvest.trees === '' || harvest.field === '')
    return error('Please enter hours, bags, trees and a field');

  return {
    type: ADD_HARVEST_TO_EDIT_TIMESHEET,
    payload: {
      ...harvest,
      id: generateGUID()
    }
  };
}
/* Selects a harvest record to edit */
export function selectHarvestToEdit(formId, harvest) {
  fillEdit(formId, harvest);
  $('#edit-harvest-btn').css('display','block');
  return {
    type: SELECT_HARVEST_TO_EDIT,
    payload: harvest
  };
}
/* Edits a selected harvest record */
export function editHarvest(formId, harvestToEdit) {
  let harvest = packageDashForm('edit-harvest-ts-form');
  harvestToEdit = {
    ...harvestToEdit,
    bags: harvest.bags,
    trees: harvest.trees,
    block: harvest.block,
    field: harvest.field,
    hours: harvest.hours,
    incentive: 0.00,
    pIndex: 0.00
  };
  $('#edit-harvest-btn').css('display','none');
  return {
    type: EDIT_HARVEST,
    payload: harvestToEdit
  };
}
/**
* selectCostCenterByLocation(): Displays cost centers by location only; once a location is selected
* @param {String} val: selected location
* @returns {Object}
* @called-in: ['/components/timesheets/create/.js]
**/
export function selectCostCenterByLocation(val) {
  return {
    type: SELECT_COST_CENTER_BY_LOCATION,
    payload: val
  };
}
/**
* autoFillGangTimesheet(): Autofills gang timesheet inputs; up to 3 inputs per employee
* @param {Object} formObj: autofill form object
* @returns {Object}
* @called-in: ['/components/timesheets/create/gang_autofill_form.js]
**/
export function autoFillGangTimesheet(formObj) {
  $('#emp-list-gang input').each(function () {
      let id = this.id.split('-');
      if (formObj.count === "1" && id.length === 2) {
        if (id[1] === 'bags') this.value = formObj.bags;
        if (id[1] === 'trees') this.value = formObj.trees;
        if (id[1] === 'hours') this.value = formObj.hours;
      }
      if (formObj.count === "2" && id.length === 3 && id[1] === "0") {
        if (id[2] === 'bags') this.value = formObj.bags;
        if (id[2] === 'trees') this.value = formObj.trees;
        if (id[2] === 'hours') this.value = formObj.hours;
      }
      if (formObj.count === "3" && id.length === 3 && id[1] === "1") {
        if (id[2] === 'bags') this.value = formObj.bags;
        if (id[2] === 'trees') this.value = formObj.trees;
        if (id[2] === 'hours') this.value = formObj.hours;
      }
      if (formObj.count === "4" && id.length === 3 && id[1] === "2") {
        if (id[2] === 'bags') this.value = formObj.bags;
        if (id[2] === 'trees') this.value = formObj.trees;
        if (id[2] === 'hours') this.value = formObj.hours;
      }
      if (formObj.count === "5" && id.length === 3 && id[1] === "3") {
        if (id[2] === 'bags') this.value = formObj.bags;
        if (id[2] === 'trees') this.value = formObj.trees;
        if (id[2] === 'hours') this.value = formObj.hours;
      }
  });
  $('#emp-list-gang select').each(function () {
      let id = this.id.split('-');
      if (formObj.count === "1" && id.length === 2) {
        if (id[1] === 'field') this.value = formObj.field;
        if (id[1] === 'block') this.value = formObj.block;
      }
      if (formObj.count === "2" && id.length === 3 && id[1] === "0") {
        if (id[2] === 'field') this.value = formObj.field;
        if (id[2] === 'block') this.value = formObj.block;
      }
      if (formObj.count === "3" && id.length === 3 && id[1] === "1") {
        if (id[2] === 'field') this.value = formObj.field;
        if (id[2] === 'block') this.value = formObj.block;
      }
      if (formObj.count === "4" && id.length === 3 && id[1] === "2") {
        if (id[2] === 'field') this.value = formObj.field;
        if (id[2] === 'block') this.value = formObj.block;
      }
      if (formObj.count === "5" && id.length === 3 && id[1] === "3") {
        if (id[2] === 'field') this.value = formObj.field;
        if (id[2] === 'block') this.value = formObj.block;
      }
  });
  return {
    type: AUTOFILL_GANG_TIMESHEET
  };
}











/* END */



// WEBPACK FOOTER //
// ./src/actions/index.js